import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import IntlMessages from "../../../services/intlMesseges";
import * as Permission from "../../../services/permissions";
import { Table, Icon, Input, Button, Row, Col, Typography, Tag } from "antd";
import { EditCell } from "../../shared/components/helperCells";
import * as countriesActions from "../../../redux/actions/countries-actions";
import * as adminActions from "../../../redux/actions/admin-actions";
import * as userActions from "../../../redux/actions/user-actions";
import * as tiersActions from "../../../redux/actions/tiers-actions";
import * as paginationActions from "../../../redux/actions/pagination-actions";

class ManageStates extends Component {
  constructor(props) {
    super(props);
    this.module = "pricing_countries";
    this.state = {
      riskId: 0,
      loading: false,
      data: [],
      pagination: {
        pageSize: 10,
        current: 1,
        hideOnSinglePage: true,
        showTotal: (total, range) => {
          return (
            <span>
              <IntlMessages id="admin.text.showing" /> {range[0]}-{range[1]}{" "}
              <IntlMessages id="admin.text.of" /> {total}{" "}
              <IntlMessages id="admin.text.results" />
            </span>
          );
        },
      },
      filters: {},
    };
  }
  getSelectedFilterValue = (index) => {
    return (
      (this.props.paginginfo[this.module] &&
        this.props.paginginfo[this.module].filter &&
        this.props.paginginfo[this.module].filter[index]) ||
      null
    );
  };

  getHeaderKeys = () => {
    let keys = [
      {
        // title: <IntlMessages id="admin.countries.countryName" />,
        title: <IntlMessages id="admin.managestate.statename" />,
        dataIndex: "stateName",
        ...this.getColumnSearchProps("stateName"),
        filteredValue: this.getSelectedFilterValue("stateName"),
        //width: "25%"
      },
      {
        title: <IntlMessages id="admin.managestate.statecode" />,
        dataIndex: "stateCode",
        // width: "25%"
      },

      {
        title: <IntlMessages id="admin.userlisting.status" />,
        rowKey: "action",
        //width: "25%",
        render: (_text, record) => (
          <span>
            {record.isActive === true ? (
              <Tag color="green">
                <IntlMessages id="admin.status.active" />
              </Tag>
            ) : (
              <Tag color="red">
                <IntlMessages id="admin.status.inactive" />
              </Tag>
            )}
          </span>
        ),
      },
    ];
    if (Permission.isRole("Administrator")) {
      keys.push({
        title: <IntlMessages id="admin.userlisting.action" />,
        rowKey: "action",
        // width: "25%",
        render: (_text, record) => (
          <span>
            <EditCell
              onEditCell={() => {
                this.editItem(record.stateId);
              }}
            />
          </span>
        ),
      });
    }
    return keys;
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => {
      return (
        <div style={{ padding: 8 }}>
          <Input
            ref={(node) => {
              this.searchInput = node;
            }}
            value={selectedKeys}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? e.target.value.trimLeft() : "")
            }
            onPressEnter={() =>
              this.handleSearch(
                selectedKeys,
                confirm,
                dataIndex,
                clearFilters,
                setSelectedKeys
              )
            }
            style={{ width: 188, marginBottom: 8, display: "block" }}
          />
          <Button
            type="primary"
            onClick={() =>
              this.handleSearch(
                selectedKeys,
                confirm,
                dataIndex,
                clearFilters,
                setSelectedKeys
              )
            }
            disabled={
              selectedKeys != "" && selectedKeys !== null ? false : true
            }
            icon="search"
            size="small"
            style={{ width: 90, marginRight: 8 }}
          >
            <IntlMessages id="admin.search" />
          </Button>
          <Button
            disabled={
              selectedKeys != "" && selectedKeys !== null ? false : true
            }
            onClick={() => this.handleReset(clearFilters, dataIndex)}
            size="small"
            style={{ width: 90 }}
          >
            <IntlMessages id="admin.reset" />
          </Button>
        </div>
      );
    },
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
  });

  handleSearch = (
    selectedKeys,
    confirm,
    dataIndex,
    clearFilters,
    setSelectedKeys
  ) => {
    if (selectedKeys == "") {
      return false;
    }

    this.setState({ searchText: selectedKeys });
    let filters = this.state.filters;
    filters[dataIndex] = {
      val: selectedKeys,
      clearf: clearFilters,
      filter: true,
      setSelectedKeys: setSelectedKeys,
      confirm: confirm,
      auto: true,
    };
    this.setState({ filters: filters });
    this.props.updateFilters({ module: this.module, filters: filters });
    confirm();
  };

  handleReset = (clearFilters, dataIndex) => {
    clearFilters();
    let filters = this.state.filters;
    if (filters[dataIndex]) {
      if (
        filters[dataIndex].setSelectedKeys &&
        typeof filters[dataIndex].setSelectedKeys === "function"
      ) {
        filters[dataIndex].setSelectedKeys("");
        //filters[dataIndex].confirm();
      }
    }
    if (filters[dataIndex] && !filters[dataIndex].auto) {
      delete this.props.paginginfo[this.module].filter[dataIndex];
      this.handleTableChange(
        { current: 1, pageSize: 10 },
        this.props.paginginfo[this.module].filter,
        {}
      );
    }
    filters[dataIndex] = { val: "", clearf: "", filter: false };
    this.setState({ filters: filters });
    this.props.updateFilters({ module: this.module, filters: filters });
    this.setState({ searchText: "" });
  };

  async componentDidMount() {
    this.props.clearPaginationExceptMe(this.module);
    if (this.props.paginginfo && this.props.paginginfo[this.module]) {
      this.handleTableChange(
        this.props.paginginfo[this.module].pagination,
        this.props.paginginfo[this.module].filter,
        {},
        true
      );
      if (this.props.paginginfo[this.module].filters) {
        let filters = this.props.paginginfo[this.module].filters;
        Object.keys(filters).map((k) => {
          filters[k].auto = false;
        });
        this.setState({ filters: filters });
     
      }
    } else {
      this.handleTableChange({ current: 1, pageSize: 10 }, {}, {}, true);
    }
  }
  
  editItem = (id) => {
    this.props.history.push("" + id);
  };

  handleTableChange = (pagination, filters, sorter, manual) => {
    if (filters === undefined) filters = {};
    Object.keys(filters).map((key) => {
      if (
        !filters[key] ||
        (Array.isArray(filters[key]) && filters[key].length === 0)
      ) {
        delete filters[key];
      }
    });
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    if (manual !== true) {
      this.props.updatePaginationRemoveOld({
        module: this.module,
        filter: filters,
        pagination: {
          current: pagination.current,
          pageSize: pagination.pageSize,
        },
      });
    }
    this.setState({ loading: true });
    this.props
      .getCountryStateList({
        filters: filters,
        pagination: { page: pagination.current, pageSize: pagination.pageSize },
        sorter: sorter
      })
      .then((resp) => {
        if(resp.countryStates && resp.countryStates.length > 0) {
          resp.countryStates.map((countryState, i) => {
            if(countryState && countryState.stateRiskZones && countryState.stateRiskZones.length > 0) {
              var tempZones= "";
               countryState.stateRiskZones.map((stateRiskZone, index) => {
                tempZones = tempZones + (index === 0 || index === stateRiskZone.length-1 ? "":", ")+stateRiskZone.stateRiskTypeId;
              })
              if(tempZones === "1") {
              resp.countryStates[i]["stateRiskTypeIds"] = "High Risk";
              } else {
                resp.countryStates[i]["stateRiskTypeIds"] = "Low Risk";
              }
            }
          })
        }
        pager.total = resp.recordCount;
              this.setState({
                loading: false,
                data: resp.results,
                pagination: pager
              });
      })
      .catch((ex) => {
        this.setState({ loading: false });
      });
  };

  render() {
    let _state = this.state;
    let _this = this;
    let filtertag = Object.keys(this.state.filters).map(function(key1) {
      let keyLabel = _this.getHeaderKeys().find((el) => el.dataIndex === key1);
      if (keyLabel.title.props && keyLabel.title.props.id) {
        keyLabel = <IntlMessages id={keyLabel.title.props.id} />;
      } else {
        keyLabel = key1;
      }
      if (_state.filters[key1].filter) {
        return (
          <span>
            <Button
              key={key1}
              type="primary"
              onClick={() =>
                _this.handleReset(_state.filters[key1].clearf, key1)
              }
            >
              {keyLabel} : {_state.filters[key1].val}
              <Icon type="close" />
            </Button>
            &nbsp;
          </span>
        );
      }
    });

    return (
      <div>
        <Row gutter={24}>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography.Title level={4}><IntlMessages id="admin.managestate.manageStates" /></Typography.Title>
          </Col>
          {Permission.isRole("Administrator") ? (
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
              <Button
                type="primary"
                onClick={() => this.editItem("new")}
                className="right-fl def-blue"
              >
                <IntlMessages id="admin.userlisting.addnew" />
              </Button>
            </Col>
          ) : (
            ""
          )}
        </Row>
        <hr></hr>
        <Row gutter={24} style={{ marginBOttom: "20px" }}>
          <Col xs={24}>{filtertag}</Col>
        </Row>
        <Row gutter={24}>
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={24}
            xl={24}
            style={{ overflowX: "auto" }}
          >
            <Table
              columns={this.getHeaderKeys()}
              rowKey={(record) => record.userId}
              dataSource={this.state.data}
              pagination={this.state.pagination}
              loading={this.state.loading}
              onChange={this.handleTableChange}
              bordered
            />
          </Col>
        </Row>
      </div>
    );
  }
}
ManageStates.propTypes = {
  location: PropTypes.object,
  // getCountriesListing: PropTypes.func,
  getCountryStateList: PropTypes.func
};
function mapStateToProps(state) {
  return {
    ...state.tiers,
    ...state.user,
    ...state.pagination,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...countriesActions,
      ...userActions,
      ...tiersActions,
      ...paginationActions,
      ...adminActions
    },
    dispatch
  );
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(
    ManageStates
  )
);
